import { ControlType, FetchStatus, Property } from "../../../../../base/types";
import { DropdownProperties, useDropdownProperties } from "./DropdownProperties";
import { ErrorMessage, Spinner } from "../../../../../widgets";
import { FC, useCallback } from "react";

import { DraftDropdownComponent } from "./DraftDropdownComponent";
import { DropdownField } from "./DropdownField";
import { IControlAttributes } from "../../../../../base/models";
import { InputLabel } from "../../InputLabel";
import { Registry } from "../../../../../base/register";
import { SimpleDropdown } from "./SimpleDropdown";

export const DropdownComponent: FC<IControlAttributes> = ({
    control, className, props
}) => {
    const { status, properties, bindings, error } = useDropdownProperties(props);
    const { label, required, title } = properties || {}
    const containerClass = label ? className : ''
    const inputClass = label ? '' : className

    const getDropdown = useCallback(() => {
        const binding = bindings?.getBinding(Property.InitValue);
        switch (binding?.type) {
            case "Field":
                return <DropdownField
                    id={control.controlId}
                    title={title}
                    name={binding.boundValue}
                    {...properties}
                    className={inputClass}
                />
            case "Const":
            case "Expression":
            default:
                return <SimpleDropdown
                    id={control.controlId}
                    title={title}
                    {...properties}
                    options={properties?.options}
                    value={binding?.value}
                    className={inputClass}
                />
        }

        // eslint-disable-next-line
    }, [properties, bindings, control])

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <InputLabel
        htmlFor={control.controlId}
        title={title}
        label={label}
        required={required}
        className={containerClass}>
        {getDropdown()}
    </InputLabel>
}

Registry.addControl({
    id: "985b0ad8-bf42-41ec-b701-466e7866e4c3",
    name: "Dropdown",
    type: ControlType.Dropdown,
    properties: DropdownProperties,
    component: DropdownComponent,
    draftComponent: DraftDropdownComponent
})
